import { render } from "./S300286.vue?vue&type=template&id=e40bf850"
const script = {}
script.render = render

export default script